import { TASK_FILTERS } from "../hooks/taskFilters";

// Full class strings (Tailwind can't see dynamically-built names), keyed by accent.
const DOT = {
  zinc: "bg-zinc-800",
  red: "bg-red-600",
  primary: "bg-primary-500",
  blue: "bg-blue-600",
  amber: "bg-amber-600",
  green: "bg-green-700",
};

const SELECTED = {
  zinc: "bg-zinc-100 border-zinc-300 text-zinc-900",
  red: "bg-red-50 border-red-200 text-red-600",
  primary: "bg-primary-50 border-primary-200 text-primary-600",
  blue: "bg-blue-50 border-blue-200 text-blue-600",
  amber: "bg-amber-50 border-amber-200 text-amber-600",
  green: "bg-green-50 border-green-300 text-green-700",
};

const UNSELECTED =
  "bg-white border-zinc-200 text-zinc-600 hover:bg-zinc-50 hover:text-zinc-800";

const TaskFilters = ({ filters = TASK_FILTERS, counts, active, onChange, label = "Task filters", allDot = false }) => (
  <div className="flex flex-wrap items-center gap-2" role="tablist" aria-label={label}>
    {filters.map((f) => {
      const isActive = f.key === active;
      return (
        <button
          key={f.key}
          type="button"
          role="tab"
          aria-selected={isActive}
          onClick={() => onChange(f.key)}
          className={
            "inline-flex items-center gap-1.5 rounded-full border px-3.5 py-1.5 text-xs transition-colors " +
            (isActive ? "font-semibold " + SELECTED[f.accent] : "font-medium " + UNSELECTED)
          }
        >
          {f.accent && (f.key !== "all" || allDot) && (
            <span className={"size-1.5 shrink-0 rounded-full " + (DOT[f.accent] ?? "bg-zinc-400")} />
          )}
          <span>{f.label}</span>
          <span className={isActive ? "" : "text-zinc-400"}>· {counts[f.key] ?? 0}</span>
        </button>
      );
    })}
  </div>
);

export default TaskFilters;
